export function getCollaboratorUserIds(collaborators = []) {
  if (!Array.isArray(collaborators)) return [];

  return collaborators
    .map(
      (collaborator) =>
        collaborator?.user_id ??
        collaborator?.collaborator_user_id ??
        collaborator?.collaborator?.user_id ??
        collaborator?.user?.user_id
    )
    .filter((userId) => Boolean(userId));
}

export function getAssigneeOptions(boardUsers = [], collaboratorUserIds = [], assignedToUserId) {
  return (
    boardUsers
      ?.filter(
        (user) =>
          user?.active &&
          !(
            collaboratorUserIds.includes(user?.user_id) &&
            user?.user_id !== assignedToUserId
          )
      )
      ?.sort((firstUser, secondUser) =>
        firstUser?.username?.localeCompare(secondUser?.username)
      ) || []
  );
}

export function getCollaboratorOptions(boardUsers = [], collaboratorUserIds = [], assignedToUserId) {
  return (
    boardUsers
      ?.filter(
        (user) =>
          user?.active &&
          user?.user_id !== assignedToUserId &&
          !collaboratorUserIds.includes(user?.user_id)
      )
      ?.sort((firstUser, secondUser) =>
        firstUser?.username?.localeCompare(secondUser?.username)
      )
      ?.map((user) => ({
        label: user?.username,
        value: user?.user_id,
        user_image: user.user_image
      })) || []
  );
}
